module.exports = __webpack_public_path__ + "img/fish_eel.ff5c0acf.png";